/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Buildhover_Unknowndeveloper2Inputs */

const id_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembang Tidak Diketahui`)
};

const ms_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangun Tidak Diketahui`)
};

const da_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt Udvikler`)
};

const de_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Entwickler`)
};

const en_us2_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Developer`)
};

const es_es2_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador desconocido`)
};

const es_mx2_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador desconocido`)
};

const fil_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Kilalang Developer`)
};

const fr_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur inconnu`)
};

const it_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatore sconosciuto`)
};

const hu_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen fejlesztő`)
};

const nl_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende ontwikkelaar`)
};

const no_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent utvikler`)
};

const pl_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznany deweloper`)
};

const pt_br2_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor desconhecido`)
};

const pt_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor desconhecido`)
};

const ro_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezvoltator necunoscut`)
};

const fi_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon kehittäjä`)
};

const sv_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänd utvecklare`)
};

const vi_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà phát triển không xác định`)
};

const tr_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen Geliştirici`)
};

const cs_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámý vývojář`)
};

const bg_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непознат разработчик`)
};

const ru_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный разработчик`)
};

const uk_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідомий розробник`)
};

const ar_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور غير معروف`)
};

const hi_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात डेवलपर`)
};

const th_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้พัฒนาไม่ทราบชื่อ`)
};

const ja_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明な開発者`)
};

const zh_cn2_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知开发商`)
};

const zh_hant1_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知開發商`)
};

const ko_home_buildhover_unknowndeveloper2 = /** @type {(inputs: Home_Buildhover_Unknowndeveloper2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 개발자`)
};

/**
* | output |
* | --- |
* | "Unknown Developer" |
*
* @param {Home_Buildhover_Unknowndeveloper2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_buildhover_unknowndeveloper2 = /** @type {((inputs?: Home_Buildhover_Unknowndeveloper2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Buildhover_Unknowndeveloper2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "ms") return ms_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "da") return da_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "de") return de_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "en-US") return en_us2_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "es-ES") return es_es2_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "es-MX") return es_mx2_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "fil") return fil_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "fr") return fr_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "it") return it_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "hu") return hu_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "nl") return nl_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "no") return no_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "pl") return pl_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "pt-BR") return pt_br2_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "pt") return pt_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "ro") return ro_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "fi") return fi_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "sv") return sv_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "vi") return vi_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "tr") return tr_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "cs") return cs_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "bg") return bg_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "ru") return ru_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "uk") return uk_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "ar") return ar_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "hi") return hi_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "th") return th_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "ja") return ja_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_buildhover_unknowndeveloper2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_buildhover_unknowndeveloper2(inputs)
	return ko_home_buildhover_unknowndeveloper2(inputs)
});
export { home_buildhover_unknowndeveloper2 as "home.buildHover.unknownDeveloper" }